import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/content-wrapper/content-wrapper.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/navbar/index.tsx");
